import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './components/table/table.component';
import { TabBarComponent } from './components/tab-bar/tab-bar.component';
import { AlertBarComponent } from './components/alert-bar/alert-bar.component';
import { AppModalComponent } from './components/app-modal/app-modal.component';
import { RightModalComponent } from './components/right-modal/right-modal.component';
import { UiStepperComponent } from './components/ui-stepper/ui-stepper.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { CampFacilityPipe, CampPaymentFlowPipe, CampServicePipe, DefaultImagePipe, DocumentNamePipe, DocumentPipe, ImagePipe, LanguagePipe, NameFormatPipe, RemoveUnderscorePipe } from '../../pipes/common.pipe';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";
import { ConfirmationBarComponent } from './components/confirmation-bar/confirmation-bar.component';
import { FileComponent } from './components/file/file.component';
import { AddressDirective } from '../../directives/address.directive';
import { AclDirective } from './directives/acl.directive';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Loader } from '@googlemaps/js-api-loader';
import { ExportViewerComponent } from './components/export-viewer/export-viewer.component';


@NgModule({
  declarations: [
    TableComponent,
    TabBarComponent,
    AlertBarComponent,
    ImagePipe,
    AppModalComponent,
    RightModalComponent,
    UiStepperComponent,
    UiStepperComponent,
    UploadFileComponent,
    DefaultImagePipe,
    ConfirmationBarComponent,
    FileComponent,
    ImagePipe,
    LanguagePipe,
    DefaultImagePipe,
    DocumentPipe,
    RemoveUnderscorePipe,
    NameFormatPipe,
    DocumentNamePipe,
    CampFacilityPipe,
    CampServicePipe,
    CampPaymentFlowPipe,
    AddressDirective,
    AclDirective,
    MultiSelectDropdownComponent,
    ExportViewerComponent
  ],
  imports: [
    CommonModule,
    // GooglePlaceModule,
    NgxGpAutocompleteModule,
    FormsModule,
    MatTooltipModule,
    MatIconModule
  ],
  exports: [
    TableComponent,
    TabBarComponent,
    AlertBarComponent,
    AppModalComponent,
    RightModalComponent,
    UiStepperComponent,
    UploadFileComponent,
    // GooglePlaceModule,
    NgxGpAutocompleteModule,
    ImagePipe,
    LanguagePipe,
    DefaultImagePipe,
    AddressDirective,
    ConfirmationBarComponent,
    FileComponent,
    RemoveUnderscorePipe,
    NameFormatPipe,
    DocumentNamePipe,
    CampFacilityPipe,
    CampServicePipe,
    CampPaymentFlowPipe,
    AclDirective,
    MultiSelectDropdownComponent,
    MatTooltipModule,
    MatIconModule,
    ExportViewerComponent
  ],
  providers: [
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: 'YOUR_API_KEY',
        libraries: ['places']
      })
    },
  ]
})
export class SharedModule {
}
